import type { CalendarProviderAccount } from '../store/schema/CalendarProviderAccount';
import type { CalendarProviderType } from '../store/schema/CalendarProviderType';
import { getStore } from '../store/store';
import { ConnectedAccountState } from 'owa-link-account';

export function getCalendarProviderAccounts(): CalendarProviderAccount[] {
    return getStore().providerAccounts;
}

export function getCalendarProviderAccountForType(
    providerType: CalendarProviderType
): CalendarProviderAccount | null {
    // As for now we intend to only have one account with a specific provider type
    // hence we return single account if its there
    const [providerAccount] = getStore().providerAccounts.filter(
        pa => pa.providerType === providerType
    );

    return providerAccount || null;
}

export function isCalendarProviderAccountUnauthorized(providerType: CalendarProviderType): boolean {
    const store = getStore();
    const [providerAccount] = store.providerAccounts.filter(pa => pa.providerType === providerType);

    return (
        !!providerAccount &&
        (providerAccount.state === ConnectedAccountState.Revoked ||
            store.providerAccountUnauthorized.has(providerAccount.id))
    );
}
